export const DEFAULT_CHECKOUT_ERROR_MESSAGE =
  "We couldn't start your checkout. Please try again, or contact support if the problem continues.";

export const ALREADY_SUBSCRIBED_MESSAGE =
  'You already have an active subscription, so there is nothing to buy. Go to your account to see or change your plan.';

// user-api raises SubscriptionAlreadyExists with this exact message (HTTP 422) when an active
// customer reselects a plan they are already on. Without this the UI showed the generic
// "Oops! Something went wrong." (SYS-20704).
const ALREADY_SUBSCRIBED_GRAPHQL_MESSAGE = 'You already have a subscription';

type MaybeApolloError = { graphQLErrors?: ReadonlyArray<{ message?: string } | undefined> };

export const getCheckoutErrorMessage = (error: unknown): string => {
  const { graphQLErrors } = (error as MaybeApolloError | undefined) ?? {};

  const isAlreadySubscribed =
    Array.isArray(graphQLErrors) &&
    graphQLErrors.some(
      graphQLError => graphQLError?.message === ALREADY_SUBSCRIBED_GRAPHQL_MESSAGE,
    );

  return isAlreadySubscribed ? ALREADY_SUBSCRIBED_MESSAGE : DEFAULT_CHECKOUT_ERROR_MESSAGE;
};
